module.exports = __webpack_public_path__ + "img/INVERTER(BOARD FLIPPER).02aa28aa.jpg";